// extracted by mini-css-extract-plugin
export default {"prose":"About_prose__6UPxG"};